(function () {
    // 注册组件
    SR.modules.extend('autoAsk', autoAsk);

    function autoAsk() {
        this.queryQuestion = function() {
            var question = SR.util.urlParam('ask');
            if (question) {
                question = decodeURIComponent(question);
                window.ask(question);
            }
        }
        this.queryQuestion();
    }
}());